import React, { useState } from "react";
import "./SoftwareDevelopment.scss";
import softwareDevelopmentBaner from "../../../../Assets/Red_Theme/services/details/softwareDevelopmentBaner.png";
import QuoteModal from "../../../../Components/QuoteModal";
import chooseVidhan1 from "../../../../Assets/Red_Theme/chooseVidhan1.png";
import chooseVidhan2 from "../../../../Assets/Red_Theme/chooseVidhan2.png";
import chooseVidhan3 from "../../../../Assets/Red_Theme/chooseVidhan3.png";
import chooseVidhan4 from "../../../../Assets/Red_Theme/chooseVidhan4.png";
import CountUp from "react-countup";
import consultancy from "../../../../Assets/Red_Theme/softwareDevelopmentProcessIcon/consultancy.png";
import uiuxDesign from "../../../../Assets/Red_Theme/softwareDevelopmentProcessIcon/uiuxDesign.png";
import development from "../../../../Assets/Red_Theme/softwareDevelopmentProcessIcon/development.png";
import testingandqa from "../../../../Assets/Red_Theme/softwareDevelopmentProcessIcon/testingandqa.png";
import deployment from "../../../../Assets/Red_Theme/softwareDevelopmentProcessIcon/deployment.png";
import maintenanceSupport from "../../../../Assets/Red_Theme/softwareDevelopmentProcessIcon/maintenanceSupport.png";
import LetDiscuss from "../../../../Components/LetDiscuss";
import TechnologyStackindex from "../../../../Components/TechnologyStack";
// const CountUp = React.lazy(() => import("react-countup"));
function CountUpBox(props) {
  return (
    <div className={`statistic_container ${props.Class}`}>
      <div className={`about_statistic ${props.Class}`}>
        <span>
          <CountUp end={props.Count} duration={props.Duration} />
          <span className="symbol">{props.Symbol}</span>
        </span>
        <h4>{props.Title}</h4>
      </div>
    </div>
  );
}
function SoftwareDevelopment() {
  const softwareDevelopmentServices = [
    {
      title: "Software Consulting",
      desc: "Our software consulting services provide strategic insights that elevate your business ideas and development initiatives. With a deep understanding of your needs, our experts craft tailored solutions to maximize efficiency, foster growth, and scale profitability.",
    },
    {
      title: "Custom Software Development",
      desc: "At Vidhan Infotech, we specialize in custom software development services designed to align perfectly with your business goals. Our agile development approach ensures rapid delivery, continuous iterations, enhanced scalability, and seamless integration.",
    },
    {
      title: "Enterprise Software Development",
      desc: "Whether you need Enterprise Resource Planning (ERP) or Customer Relationship Management (CRM) solutions, Vidhan Infotech provides reliable enterprise software development services. We help businesses optimize workflows, enhance collaboration, and drive productivity.",
    },
    {
      title: "Software Product Development",
      desc: "Gain a competitive edge with our expert developers managing your software product from ideation to launch and maintenance. As a market-proven software product development company, we craft strategic roadmaps and assess risks for seamless execution.",
    },
    {
      title: "Artificial Intelligence Software Development",
      desc: "We specialize in custom AI software development, delivering powerful, secure, and feature-rich AI solutions tailored to your business needs. Leverage our expertise to innovate, scale, and stay ahead in the AI-driven world.",
    },
    {
      title: "Software Migration and Integration",
      desc: "With deep expertise, our vetted software engineers enhance your system while adhering to compliance standards. As a trusted US software development company, we support seamless migration, integration, and legacy modernization to future-proof your infrastructure.",
    },
    {
      title: "Custom CRM Development",
      desc: "Enhance your customer relationships with our Custom CRM development services. Our team builds user-friendly interfaces, scalable back-end systems, and seamless integrations to provide a resilient CRM solution that fits your business perfectly.",
    },
    {
      title: "API Development",
      desc: "Our tailored software development services help you create robust APIs that boost connectivity, streamline interoperability, and expand app functionality. At Vidhan Infotech, we specialize in integrating your existing systems with precision and efficiency",
    },
    {
      title: "UI/UX Design",
      desc: "We specialize in UI/UX design services that enhance usability and aesthetics for software applications, websites, and digital platforms. With a user-first mindset and mobile-ready approach, we craft seamless, engaging experiences.",
    },
    {
      title: "Software Support and Maintenance",
      desc: "We ensure your apps stay flawless with our reliable software support and maintenance services. Available 24/7, our experts deliver regular updates, performance enhancements, and uninterrupted functionality you can trust.",
    },
  ];
  const [isOpen, setOpen] = useState(false);
  const [subject, setSubject] = useState(null);
  const OpenModal = (data) => {
    setSubject(data);
    setOpen(true);
  };
  const developmentBoxes = [
    {
      title: "Financial Software Development",
      desc: "As a leading provider of custom software solutions, we deliver cutting-edge technology to streamline financial operations and enhance banking services.",
    },
    {
      title: "Insurtech Software Development",
      desc: "Our skilled software developers empower the insurance industry with advanced software solutions to expand services, enhance productivity, and drive business growth.",
    },
    {
      title: "Healthcare Software Development",
      desc: "Backed by a decade of experience, we develop responsive and tailored healthcare software solutions to enhance patient care and streamline medical operations.",
    },
    {
      title: "eCommerce Software Development",
      desc: "Our expert team delivers cutting-edge eCommerce software solutions, including inventory management, CMS customization, and seamless user engagement enhancements.",
    },
    {
      title: "Blockchain Software Development",
      desc: "Stay ahead with our expert blockchain software development services, powered by a team well-versed in the latest technological advancements.",
    },
    {
      title: "IoT Software Development",
      desc: "Leverage our expertise in IoT software development to create flexible, high-performance solutions that integrate with hardware and address real-world challenges.",
    },
    {
      title: "Logistic Software Development Solutions",
      desc: "Our advanced logistics software solutions empower businesses with efficient inventory management, real-time tracking, enhanced user engagement, and seamless communication.",
    },
    {
      title: "Travel & Hospitality Software Solutions",
      desc: "ransform your travel and hospitality business with our modern software solutions, designed for seamless bookings, efficient tour management, and superior customer engagement.",
    },
  ];
  const developmentProcessWeFollow = [
    {
      img: consultancy,
      title: "Consultancy",
      desc: "Our experts engage in in-depth discussions about your business model, brainstorming strategies to ensure seamless project planning and development.",
    },
    {
      img: uiuxDesign,
      title: "UI/UX Design",
      desc: "The Software design process will be in action as per business requirements, along with system architecture, functions, and graphics.",
    },
    {
      img: development,
      title: "Development",
      desc: "Our skilled developers begin coding using your preferred platforms, frameworks, and programming languages to deliver tailored solutions.",
    },
    {
      img: testingandqa,
      title: "Testing and QA",
      desc: "Our quality analysts and test engineers meticulously test the software to eliminate errors and ensure a seamless, bug-free experience.",
    },
    {
      img: deployment,
      title: "Deployment",
      desc: "At this stage, our development team initiates the deployment process, ensuring the ready-to-launch software is successfully released.",
    },
    {
      img: maintenanceSupport,
      title: "Maintenance & Support",
      desc: "Our skilled developers begin coding using your preferred platforms, frameworks, and programming languages to deliver tailored solutions.",
    },
  ];
  const TechnologyStackData = {
    title: (
      <h2>
        Technical <span>Stack</span> We Cover
      </h2>
    ),
    desc: "We use top-of-the-line tools, cutting-edge technologies, and modern approaches to expand and grow your business. Our technical stack for delivering exceptional software development projects includes the following trusted components.",
  };
  return (
    <>
      <section className="softwareDevelopment">
        <div className="container">
          <div className="row top">
            <div className="col-lg-6">
              <div className="softwareDevelopmentTitle">
                <h1>
                  Custom Software Development <span>Solutions</span>
                </h1>
                <p>
                  We are a top-tier software development company where expertise
                  blends with innovation. From startups to global enterprises,
                  we provide tailored software solutions that accelerate growth.
                  Whether you&apos;re launching a new product or upgrading
                  existing software, our expert developers leverage the latest
                  technologies to bring your vision to life.
                </p>
                <button
                  className="theme_btn"
                  onClick={() =>
                    OpenModal("Custom Software Development Solutions")
                  }
                >
                  <span>Let&apos;s Discuss Dream Project</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 rightSide">
              <img
                src={softwareDevelopmentBaner}
                alt="softwareDevelopmentBaner"
                title="softwareDevelopmentBaner"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="row bottom">
            <div className="col-lg-6">
              <div className="softwareDevelopmentTitle">
                <h2>
                  Our Software Development <span>Services</span>
                </h2>
                <p>
                  Empowering businesses with cutting-edge software solutions, we
                  offer end-to-end development services customized for
                  automation, security, and exceptional user experiences.
                  Explore our innovative offerings now.
                </p>
                <button
                  className="theme_btn"
                  onClick={() =>
                    OpenModal("Custom Software Development Solutions")
                  }
                >
                  <span>Contact with our expert</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 rightSide">
              {softwareDevelopmentServices.map((item, i) => (
                <div className="box" key={i}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TechnologyStackindex TechnologyStackData={TechnologyStackData} />
      <section className="chooseVidhanInfotechSolution">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="softwareDevelopmentTitle">
                <h2>
                  Choose Vidhan Infotech <span>Solutions</span> for Your Next
                  Project
                </h2>
                <p>
                  As a leading software development company, we provide highly
                  innovative and profitable software application development
                  services. Our custom solutions are trusted by top tech
                  companies across industries like healthcare, eCommerce, and
                  finance.
                </p>
                <p>
                  Leverage our experienced and forward-thinking software
                  developers to bring your vision to life. We specialize in
                  solving complex challenges with creative, efficient solutions.
                  Trust our team for your next big project.
                </p>
                <button
                  className="theme_btn"
                  onClick={() =>
                    OpenModal("Custom Software Development Solutions")
                  }
                >
                  <span>Check Our Portfolio</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="rightImg">
                <div className="imgbox">
                  <img src={chooseVidhan1} alt="" />
                  <img src={chooseVidhan2} alt="" />
                </div>
                <div className="imgbox">
                  <img src={chooseVidhan3} alt="" />
                  <img src={chooseVidhan4} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industrialSoftwareApplication">
        <div className="container">
          <div className="softwareDevelopmentTitle">
            <h2>
              <span>Industrial</span> Software Application Development Solutions
            </h2>
            <p>
              Delivering cutting-edge industrial software solutions tailored to
              your business needs. Empower your operations with innovative,
              scalable, and efficient applications.
            </p>
          </div>
        </div>
        <div className="developmentBoxes">
          {developmentBoxes.map((item, i) => (
            <div className="box" key={i}>
              <div className="content">
                <h4>{item?.title}</h4>
                <p>{item?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="letsWorkTogether">
        <div className="container">
          <div className="counterBoxes">
            <CountUpBox
                    Class=""
                    Count="61"
                    Symbol="+"
                    Duration="3"
                    Title="Happy Clients"
                  />
                  <CountUpBox
                    Class=""
                    Count="82"
                    Symbol="+"
                    Duration="3"
                    Title="Project Delivered"
                  />
                  <CountUpBox
                    Class=""
                    Count="20"
                    Symbol="+"
                    Duration="3"
                    Title="Team Members"
                  />
                  <CountUpBox
                    Class=""
                    Count="8"
                    Symbol="+"
                    Duration="3"
                    Title="Years Experience"
                  />
          </div>
          <hr />
          <button className="theme_btn">
            <span>Let’s Work Together</span>
          </button>
        </div>
      </section>
      <section className="softwareDevelopmentProcessWeFollow">
        <div className="container">
          <div className="softwareDevelopmentTitle">
            <h2>
              Software Development <span>Process</span> We Follow
            </h2>
            <p>
              Delivering cutting-edge industrial software solutions tailored to
              your business needs. Empower your operations with innovative,
              scalable, and efficient applications.
            </p>
          </div>
          <div className="developmentProcessWeFollow">
            {developmentProcessWeFollow.map((item, i) => (
              <div className="box" key={i}>
                <span>0{i + 1}</span>
                <div className="icon">
                  <img src={item?.img} alt={item?.title} title={item?.title} />
                </div>
                <h3>{item?.title}</h3>
                <p>{item?.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <LetDiscuss />
      {/* <section className="letsdiscussYourProject">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="uiuxViewService_header_content">
                <h2 className="text-center">
                  Let&apos;s <span>discuss</span>Your Project
                </h2>
              </div>
            </div>
            <div className="col-md-4">
              <input
                type="text"
                placeholder="Your Name"
                name=""
                id=""
                className="form-control custome-input"
              />
            </div>
            <div className="col-md-4">
              <input
                type="text"
                placeholder="Work Email Address"
                name=""
                id=""
                className="form-control custome-input"
              />
            </div>
            <div className="col-md-4">
              <input
                type="text"
                placeholder="Phone Number"
                name=""
                id=""
                className="form-control custome-input"
              />
            </div>
            <div className="col-md-12 mt-4">
              <textarea
                name=""
                id=""
                rows={5}
                className="form-control custome-input"
                placeholder="Describe Your Requirement"
              ></textarea>
            </div>
            <div className="col-md-12 text-center mt-5">
              <button className="theme_btn bordered m-auto ">
                <span>Inquire Now</span>
              </button>
            </div>
          </div>
        </div>
      </section> */}
      {isOpen && (
        <QuoteModal
          open={isOpen}
          setOpen={setOpen}
          CloseModal={() => setOpen(false)}
          subject={subject}
        />
      )}
    </>
  );
}
export default React.memo(SoftwareDevelopment);
